import { t } from "@hakili/i18n";
import { Button, Callout } from "@hakili/ui";
import { Scale } from "lucide-react";

import { COMPOSER_WARN_ICON } from "../routes/composer.js";

/**
 * `POLICY-FIRST`, Screen B (D-1028-6 point 3; D2 `b284f616`, frames 166 and 168): the warn banner above the title of every screen but the
 * Politique while the bank has no credit policy. The chef is told to define it, the analyst that the chef does and that nothing arrives
 * until then. The fact is the door's own (`GET /bank/policy` answering `policy: null`), passed in by the shell; nothing is guessed here.
 */
export function PolicyMissingBanner(props: {
  readonly persona: "analyste" | "chef";
  readonly onGo: () => void;
}): React.JSX.Element {
  const chef = props.persona === "chef";
  return (
    <Callout tone="warn" testId="bank-politique-manquante" className="mb-4" icon={COMPOSER_WARN_ICON}>
      <p className="font-semibold">
        {t(chef ? "bank.politique.manquanteChefTitre" : "bank.politique.manquanteAnalysteTitre")}
      </p>
      <p>{t(chef ? "bank.politique.manquanteChefCorps" : "bank.politique.manquanteAnalysteCorps")}</p>
      <p className="mt-2">
        <Button variant="ghost" size="sm" data-testid="bank-politique-manquante-aller" onClick={props.onGo}>
          <span className="inline-flex items-center gap-1.5">
            <Scale className="h-3.5 w-3.5" aria-hidden="true" />
            {t(chef ? "bank.politique.manquanteChefBouton" : "bank.politique.manquanteAnalysteBouton")}
          </span>
        </Button>
      </p>
    </Callout>
  );
}
